"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  /* Order is important here, borderColor shoulc come after borders */\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  visibility: ", ";\n  box-sizing: ", ";\n  transition: ", ";\n  transform: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:hover {\n    cursor: ", ";\n  }\n\n  /* We need to use this to keep animations working in safari */\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var boxStyle = (0, _styledSystem.variant)({
  key: 'boxes'
});

var Box = _styledComponents.default.div(_templateObject(), _styledSystem.alignSelf, _styledSystem.backgroundImage, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.backgroundSize, _styledSystem.borderRadius, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.bottom, _styledSystem.boxShadow, boxStyle, _styledSystem.color, _styledSystem.display, _styledSystem.fontFamily, _styledSystem.height, _styledSystem.left, _styledSystem.maxHeight, _styledSystem.maxWidth, _styledSystem.minHeight, _styledSystem.minWidth, _styledSystem.opacity, _styledSystem.overflow, _styledSystem.position, _styledSystem.right, _styledSystem.space, _styledSystem.top, _styledSystem.width, _styledSystem.zIndex, function (props) {
  return props.visibility || 'visible';
}, function (props) {
  return props.boxSizing || 'content-box';
}, function (props) {
  return props.transition || 'all 0s 0s ease';
}, function (props) {
  return props.transform || 'none';
}, function (props) {
  return props.overflowX && "\n    overflow-x: " + props.overflowX + ";\n  ";
}, function (props) {
  return props.overflowY && "\n    overflow-y: " + props.overflowY + ";\n  ";
}, function (props) {
  return props.pointerEvents && "\n    pointer-events: " + props.pointerEvents + ";\n  ";
}, function (props) {
  return props.webkitOverflowScroll && "\n    -webkit-overflow-scrolling: " + props.webkitOverflowScroll + ";\n  ";
}, function (props) {
  return props.hover ? 'pointer' : 'auto';
}, function (props) {
  return props.isAnimationContainer && "\n    backface-visibility: hidden;\n    perspective: 1000;\n    transform-style: preserve-3d;\n  ";
});

var _default = Box;
exports.default = _default;